const DISALLOWED_TAGS = [
    'script',
    'iframe',
    'object',
    'embed',
    'form',
    'svg',
    'applet',
    'meta',
    'link',
];
const ALLOWED_ATTRIBUTES = [
    'class',
    'style',
    'alt',
    'src',
    'data-id',
    'title',
    'type',
];

export const SanitizeHTML = (htmlString: string) => {
    const parser = new DOMParser();
    const dom = parser.parseFromString(htmlString, 'text/html');

    const cleanNode = (node: Node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
            const element = node as Element;
            if (DISALLOWED_TAGS.includes(element.tagName.toLowerCase())) {
                element.remove();
                return;
            }

            Array.from(element.attributes).forEach(attribute => {
                const attrName = attribute.name.toLowerCase();
                if (!ALLOWED_ATTRIBUTES.includes(attrName)) {
                    element.removeAttribute(attribute.name);
                    return;
                }

                switch (attrName) {
                    case 'style':
                        const styleValue = attribute.value.toLowerCase();
                        if (
                            styleValue.includes('url(') ||
                            styleValue.includes('expression(')
                        ) {
                            element.removeAttribute('style');
                        }
                        break;
                    case 'src':
                        const srcValue = attribute.value.toLowerCase();
                        if (
                            !srcValue.startsWith('http') &&
                            !srcValue.startsWith('data:')
                        ) {
                            element.removeAttribute('src');
                        }
                        break;
                    case 'data-id':
                        const dataIdValue = attribute.value;
                        if (!/^[a-zA-Z0-9\-_.]+$/.test(dataIdValue)) {
                            element.removeAttribute('data-id');
                        }
                        break;
                    case 'type':
                        const typeValue = attribute.value.toLowerCase();
                        if (
                            typeValue !== 'button' &&
                            typeValue !== 'submit' &&
                            typeValue !== 'reset'
                        ) {
                            element.removeAttribute('type');
                        }
                        break;
                    case 'href':
                        const hrefValue = attribute.value.toLowerCase();
                        if (
                            !hrefValue.startsWith('http') &&
                            !hrefValue.startsWith('https') &&
                            !hrefValue.startsWith('/') &&
                            !hrefValue.startsWith('#')
                        ) {
                            element.removeAttribute('href');
                        }
                        break;
                    default:
                        break;
                }
            });
            Array.from(node.childNodes).forEach(cleanNode);
        }
    };
    Array.from(dom.body.childNodes).forEach(cleanNode);

    return dom.body.innerHTML;
};
